import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CalendarClockIcon } from 'lucide-react';
import { cadenceOptions } from '../../data/withdraw';
import { Cadence } from '../../types/withdraw';
import { firstContactDate, formatDate } from '../../utils/dates';
import { easeOut } from '../../utils/styles';
interface CadencePreviewProps {
  cadence: Cadence;
  onChange: (cadence: Cadence) => void;
}
export function CadencePreview({
  cadence,
  onChange
}: CadencePreviewProps) {
  const option = cadenceOptions.find(c => c.id === cadence) ?? cadenceOptions[1];
  const first = firstContactDate(cadence);
  return <div className="rounded-2xl border border-accent-100 bg-gradient-to-br from-accent-50 to-white p-4" data-id="element-26" data-mp="35pc8t39360wn">
      <div className="flex items-start gap-3" data-id="element-27" data-mp="30rkg470maare">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-white text-accent-600 shadow-soft" data-id="element-28" data-mp="3eq1zxtnej341">
          <CalendarClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-29" data-mp="3apzwbey3vzm4" />
        </span>
        <div className="min-w-0" aria-live="polite" data-id="element-30" data-mp="l1ie3wf2lwrd">
          <p className="text-xs font-medium text-accent-700" data-id="element-31" data-mp="l33a7qh19nrc">Follow-up cadence</p>
          <AnimatePresence mode="wait" initial={false} data-id="element-32" data-mp="p33ys3xujfc4">
            <motion.p key={cadence} initial={{
            opacity: 0,
            y: 4
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -4
          }} transition={{
            duration: 0.16,
            ease: easeOut
          }} className="mt-0.5 text-sm font-semibold text-slate-900" data-id="element-33" data-mp="u15imr33jion">
              Next contact: {option.phrase}, first on {formatDate(first, 'EEE, MMM d')}
            </motion.p>
          </AnimatePresence>
        </div>
      </div>
      <div role="radiogroup" aria-label="Follow-up cadence" className="mt-4 flex gap-0.5 rounded-full bg-white p-1 ring-1 ring-accent-100" data-id="element-34" data-mp="1hqzup6fld37u">
        {cadenceOptions.map(c => {
        const active = c.id === cadence;
        return <button key={c.id} type="button" role="radio" aria-checked={active} onClick={() => onChange(c.id)} className={`relative flex-1 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-200 ${active ? 'text-white' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-35" data-mp="1rq8ljqf5u1pz">
              {active && <motion.span layoutId="cadence-pill" className="absolute inset-0 rounded-full bg-accent-600" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 38
          }} data-id="element-36" data-mp="1ktm3kk8a176u" />}
              <span className="relative" data-id="element-37" data-mp="1ps77atmqm901">{c.label}</span>
            </button>;
      })}
      </div>
    </div>;
}